import React from "react";
import { Tooltip } from "@src/common/components";
import CourieButton from "@src/common/components/Button/Button";
import {
  ChevronDownIcon,
  ChevronUpIcon,
  PlusIcon,
} from "@heroicons/react/24/outline";
import { StopOrderRowActions } from "../utils/stopOrderRowRules";

interface StopOrderActionButtonProps {
  label: string;
  isDisabled: boolean;
  disabledReason: string | null;
  onClick: () => void;
  children: React.ReactNode;
}

function StopOrderActionButton({
  label,
  isDisabled,
  disabledReason,
  onClick,
  children,
}: StopOrderActionButtonProps) {
  const button = (
    <CourieButton
      color={"secondary"}
      className="border truncate hover:bg-gray-100 dark:hover:bg-gray-800"
      size={"xs"}
      disabled={isDisabled}
      onClick={onClick}
      aria-label={label}
    >
      {children}
      {label}
    </CourieButton>
  );
  if (!isDisabled || !disabledReason) return button;
  return (
    <Tooltip content={disabledReason}>
      <span>{button}</span>
    </Tooltip>
  );
}

interface Props {
  actions: StopOrderRowActions;
  onMoveUp: () => void;
  onMoveDown: () => void;
  onInsertBelow: () => void;
}

export function StopOrderActions({ actions, onMoveUp, onMoveDown, onInsertBelow }: Props) {
  return (
    <>
      <StopOrderActionButton
        label="Move up"
        isDisabled={!actions.canMoveUp}
        disabledReason={actions.moveUpReason}
        onClick={onMoveUp}
      >
        <ChevronUpIcon className="h-5 w-5 mr-2" />
      </StopOrderActionButton>
      <StopOrderActionButton
        label="Move down"
        isDisabled={!actions.canMoveDown}
        disabledReason={actions.moveDownReason}
        onClick={onMoveDown}
      >
        <ChevronDownIcon className="h-5 w-5 mr-2" />
      </StopOrderActionButton>
      {actions.isInsertBelowOffered && (
        <StopOrderActionButton
          label="Insert stop below"
          isDisabled={!actions.canInsertBelow}
          disabledReason={actions.insertBelowReason}
          onClick={onInsertBelow}
        >
          <PlusIcon className="h-5 w-5 mr-2" />
        </StopOrderActionButton>
      )}
    </>
  );
}
